/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React from 'react';
import { View, Text, TouchableOpacity, Dimensions } from 'react-native';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import { isNative } from '@global/screens';

const POPUP_WIDTH = 139;
const POPUP_HEIGHT = 65;
const GAP = 4;
const dimension = Dimensions.get('window');

const ManageCommentSheet = ({
  visible,
  anchorRect,
  onClose,
  onEdit,
  onDelete,
}) => {
  if (!visible || !anchorRect) {
    return null;
  }

  const spaceBelow = dimension.height - (anchorRect.y + anchorRect.height);
  const openUpward = spaceBelow < POPUP_HEIGHT + GAP;
  const top = openUpward
    ? anchorRect.y - POPUP_HEIGHT - GAP
    : anchorRect.y + anchorRect.height + GAP;
  const left = anchorRect.x + anchorRect.width - POPUP_WIDTH;

  return (
    <>
      <TouchableOpacity
        testID="manage-comment-backdrop"
        activeOpacity={1}
        onPress={onClose}
        style={{
          position: isNative ? 'absolute' : 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 8,
        }}
      />
      <View
        testID="manage-comment-sheet"
        style={{
          position: isNative ? 'absolute' : 'fixed',
          top,
          left,
          width: POPUP_WIDTH,
          backgroundColor: Colors.white,
          borderRadius: 6,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.15,
          shadowRadius: 4,
          elevation: 4,
          zIndex: 9,
        }}>
        <TouchableOpacity
          testID="manage-comment-edit"
          onPress={onEdit}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 4,
            paddingHorizontal: 12,
          }}>
          <Image
            source={require('@assets/img/icons/edit-grey.svg')}
            style={{ width: 16, height: 16, marginRight: 8 }}
            width={16}
            height={16}
            svg={true}
          />
          <Text
            style={{
              fontFamily: 'figtree-semiBold',
              fontSize: 14,
              lineHeight: 24,
              color: '#171D29',
            }}>
            Edit
          </Text>
        </TouchableOpacity>
        <View
          style={{ height: 1, width: '100%', backgroundColor: Colors.grey0 }}
        />
        <TouchableOpacity
          testID="manage-comment-delete"
          onPress={onDelete}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 4,
            paddingHorizontal: 12,
          }}>
          <Image
            source={require('@assets/img/icons/trash-red.svg')}
            style={{ width: 16, height: 16, marginRight: 8 }}
            width={16}
            height={16}
            svg={true}
          />
          <Text
            style={{
              fontFamily: 'figtree-semiBold',
              fontSize: 14,
              lineHeight: 24,
              color: '#171D29',
            }}>
            Delete
          </Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

export default ManageCommentSheet;
